import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type CanvasRenameModalAction = "confirm" | "cancel";

export function useEmitCanvasRenameModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (action: CanvasRenameModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.CanvasRenameModal,
        optionSelected: action,
      });
    },
    [accountId],
  );

  return { emit };
}
